/*!
 * devextreme-angular-test
 * Version: 17.2.8
 * Build date: Mon Feb 05 2018
 *
 * Copyright (c) 2012 - 2018 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */


import {
    Component,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';


import DevExpress from 'devextreme/bundles/dx.all';

import { NestedOptionHost } from '../../core/nested-option';
import { NestedOption } from '../../core/nested-option';



export class DxoLabelComponent extends NestedOption {
    
    get connectorColor(): string {
        return this._getOption('connectorColor');
    }
    set connectorColor(value: string) {
        this._setOption('connectorColor', value);
    }

    
    get connectorWidth(): number {
        return this._getOption('connectorWidth');
    }
    set connectorWidth(value: number) {
        this._setOption('connectorWidth', value);
    }

    
    get customizeText(): Function {
        return this._getOption('customizeText');
    }
    set customizeText(value: Function) {
        this._setOption('customizeText', value);
    }

    
    get font(): DevExpress.viz.Font {
        return this._getOption('font');
    }
    set font(value: DevExpress.viz.Font) {
        this._setOption('font', value);
    }

    
    get format(): DevExpress.ui.format|
        string {
        return this._getOption('format');
    }
    set format(value: DevExpress.ui.format|
        string) {
        this._setOption('format', value);
    }

    
    get indent(): number {
        return this._getOption('indent');
    }
    set indent(value: number) {
        this._setOption('indent', value);
    }

    
    get precision(): number {
        return this._getOption('precision');
    }
    set precision(value: number) {
        this._setOption('precision', value);
    }

    
    get visible(): boolean {
        return this._getOption('visible');
    }
    set visible(value: boolean) {
        this._setOption('visible', value);
    }

    
    get horizontalAlignment(): string {
        return this._getOption('horizontalAlignment');
    }
    set horizontalAlignment(value: string) {
        this._setOption('horizontalAlignment', value);
    }

    
    get position(): string {
        return this._getOption('position');
    }
    set position(value: string) {
        this._setOption('position', value);
    }

    
    get text(): string {
        return this._getOption('text');
    }
    set text(value: string) {
        this._setOption('text', value);
    }

    
    get verticalAlignment(): string {
        return this._getOption('verticalAlignment');
    }
    set verticalAlignment(value: string) {
        this._setOption('verticalAlignment', value);
    }

    
    get alignment(): string {
        return this._getOption('alignment');
    }
    set alignment(value: string) {
        this._setOption('alignment', value);
    }

    
    get customizeHint(): Function {
        return this._getOption('customizeHint');
    }
    set customizeHint(value: Function) {
        this._setOption('customizeHint', value);
    }

    
    get displayMode(): string {
        return this._getOption('displayMode');
    }
    set displayMode(value: string) {
        this._setOption('displayMode', value);
    }

    
    get indentFromAxis(): number {
        return this._getOption('indentFromAxis');
    }
    set indentFromAxis(value: number) {
        this._setOption('indentFromAxis', value);
    }

    
    get overlappingBehavior(): string|
        { mode?: string, rotationAngle?: number, staggeringSpacing?: number }|
        { hideFirstOrLast?: string, useAutoArrangement?: boolean } {
        return this._getOption('overlappingBehavior');
    }
    set overlappingBehavior(value: string|
        { mode?: string, rotationAngle?: number, staggeringSpacing?: number }|
        { hideFirstOrLast?: string, useAutoArrangement?: boolean }) {
        this._setOption('overlappingBehavior', value);
    }

    
    get rotationAngle(): number {
        return this._getOption('rotationAngle');
    }
    set rotationAngle(value: number) {
        this._setOption('rotationAngle', value);
    }

    
    get staggeringSpacing(): number {
        return this._getOption('staggeringSpacing');
    }
    set staggeringSpacing(value: number) {
        this._setOption('staggeringSpacing', value);
    }

    
    get argumentFormat(): DevExpress.ui.format|
        string {
        return this._getOption('argumentFormat');
    }
    set argumentFormat(value: DevExpress.ui.format|
        string) {
        this._setOption('argumentFormat', value);
    }

    
    get argumentPrecision(): number {
        return this._getOption('argumentPrecision');
    }
    set argumentPrecision(value: number) {
        this._setOption('argumentPrecision', value);
    }

    
    get backgroundColor(): string {
        return this._getOption('backgroundColor');
    }
    set backgroundColor(value: string) {
        this._setOption('backgroundColor', value);
    }

    
    get border(): any {
        return this._getOption('border');
    }
    set border(value: any) {
        this._setOption('border', value);
    }

    
    get connector(): any {
        return this._getOption('connector');
    }
    set connector(value: any) {
        this._setOption('connector', value);
    }

    
    get horizontalOffset(): number {
        return this._getOption('horizontalOffset');
    }
    set horizontalOffset(value: number) {
        this._setOption('horizontalOffset', value);
    }

    
    get percentPrecision(): number {
        return this._getOption('percentPrecision');
    }
    set percentPrecision(value: number) {
        this._setOption('percentPrecision', value);
    }

    
    get showForZeroValues(): boolean {
        return this._getOption('showForZeroValues');
    }
    set showForZeroValues(value: boolean) {
        this._setOption('showForZeroValues', value);
    }

    
    get verticalOffset(): number {
        return this._getOption('verticalOffset');
    }
    set verticalOffset(value: number) {
        this._setOption('verticalOffset', value);
    }

    
    get hideFirstOrLast(): string {
        return this._getOption('hideFirstOrLast');
    }
    set hideFirstOrLast(value: string) {
        this._setOption('hideFirstOrLast', value);
    }

    
    get indentFromTick(): number {
        return this._getOption('indentFromTick');
    }
    set indentFromTick(value: number) {
        this._setOption('indentFromTick', value);
    }

    
    get useRangeColors(): boolean {
        return this._getOption('useRangeColors');
    }
    set useRangeColors(value: boolean) {
        this._setOption('useRangeColors', value);
    }

    
    get location(): string {
        return this._getOption('location');
    }
    set location(value: string) {
        this._setOption('location', value);
    }

    
    get showColon(): boolean {
        return this._getOption('showColon');
    }
    set showColon(value: boolean) {
        this._setOption('showColon', value);
    }

    
    get radialOffset(): number {
        return this._getOption('radialOffset');
    }
    set radialOffset(value: number) {
        this._setOption('radialOffset', value);
    }

    
    get topIndent(): number {
        return this._getOption('topIndent');
    }
    set topIndent(value: number) {
        this._setOption('topIndent', value);
    }

    
    get dataField(): string {
        return this._getOption('dataField');
    }
    set dataField(value: string) {
        this._setOption('dataField', value);
    }

    
    get enabled(): boolean {
        return this._getOption('enabled');
    }
    set enabled(value: boolean) {
        this._setOption('enabled', value);
    }

    protected get _optionPath() {
        return 'label';
    }


    constructor(  parentOptionHost: NestedOptionHost,
             optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'dxo-label',
    template: '',
    styles: [''],
    providers: [NestedOptionHost]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NestedOptionHost, decorators: [{ type: SkipSelf }, { type: Host }, ]},
{type: NestedOptionHost, decorators: [{ type: Host }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'connectorColor': [{ type: Input },],
'connectorWidth': [{ type: Input },],
'customizeText': [{ type: Input },],
'font': [{ type: Input },],
'format': [{ type: Input },],
'indent': [{ type: Input },],
'precision': [{ type: Input },],
'visible': [{ type: Input },],
'horizontalAlignment': [{ type: Input },],
'position': [{ type: Input },],
'text': [{ type: Input },],
'verticalAlignment': [{ type: Input },],
'alignment': [{ type: Input },],
'customizeHint': [{ type: Input },],
'displayMode': [{ type: Input },],
'indentFromAxis': [{ type: Input },],
'overlappingBehavior': [{ type: Input },],
'rotationAngle': [{ type: Input },],
'staggeringSpacing': [{ type: Input },],
'argumentFormat': [{ type: Input },],
'argumentPrecision': [{ type: Input },],
'backgroundColor': [{ type: Input },],
'border': [{ type: Input },],
'connector': [{ type: Input },],
'horizontalOffset': [{ type: Input },],
'percentPrecision': [{ type: Input },],
'showForZeroValues': [{ type: Input },],
'verticalOffset': [{ type: Input },],
'hideFirstOrLast': [{ type: Input },],
'indentFromTick': [{ type: Input },],
'useRangeColors': [{ type: Input },],
'location': [{ type: Input },],
'showColon': [{ type: Input },],
'radialOffset': [{ type: Input },],
'topIndent': [{ type: Input },],
'dataField': [{ type: Input },],
'enabled': [{ type: Input },],
};
}


export class DxoLabelModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    DxoLabelComponent
  ],
  exports: [
    DxoLabelComponent
  ],
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
